import sidebarButtonStyles from "@/components/common/sidebar-buttons/styles/sidebar-buttons.module.scss";
import { useReferFriend } from "@/components/pages/pricing-b/hooks/use-refer-friend";
import TertiaryFilledButton from "@/components/common/tertiary-filled-button";

const InviteFriendsTertiaryButton = () => {
  const { showInviteFriendModal } = useReferFriend();

  return (
    <div className={sidebarButtonStyles.button_wrapper}>
      <TertiaryFilledButton
        text={"Invite friends"}
        onClick={showInviteFriendModal}
      />
    </div>
  );
};

export default InviteFriendsTertiaryButton;
